import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '../common/confirm-modal';
import { UploadModal } from '../custom-digital-human/upload-modal';

interface ValidMaskProps {
  figureMessage: string;
  generateType: number; // 1: 视频数字人，2:图片数字人
}

/** 失败错误信息 状态覆盖层 */
export const ValidMask: React.FC<ValidMaskProps> = ({ figureMessage, generateType }) => {
  const { t } = useTranslation();
  const [openValid, setOpenValid] = useState(false);
  const [validMessage, setValidMessage] = useState("");
  const [openUpload, setOpenUpload] = useState(false);
  const [uploadType, setUploadType] = useState<"image" | "video">("video");

  const handleValidateClick = (e: React.MouseEvent, message: string) => {
    e.stopPropagation();
    setValidMessage(message);
    setOpenValid(true);
  };

  return (
    <>
      <div
        className="absolute inset-0 bg-black/40"
        onClick={(e) => handleValidateClick(e, figureMessage || t("assets.video_card.valid.detail_description"))}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
          <p className="max-w-[96px] text-xs text-white text-left">{t("assets.video_card.valid.fail_message")}</p>
          <span className="py-[3px] px-[10px] rounded-full bg-[rgba(255,255,255,0.3)] text-xs text-white">{t("assets.video_card.valid.detail")}</span>
        </div>
      </div>
      {openValid && (
        <ConfirmModal
          open={openValid}
          onOpenChange={setOpenValid}
          title={t("assets.video_card.valid.train_failed")}
          description={validMessage}
          cancel={t("common.cancel")}
          confirm={t("assets.video_card.valid.reupload")}
          onCancel={() => setOpenValid(false)}
          onConfirm={() => {
            setOpenUpload(true);
            setUploadType(generateType === 1 ? "video" : "image");
          }}
        />
      )}
      <UploadModal open={openUpload} onOpenChange={setOpenUpload} uploadType={uploadType} />
    </>
  )
}
